import { Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  NullableBooleanInput,
  RecordContextProvider,
  SaveButton,
  SimpleForm,
  TextInput,
  required,
  useNotify,
  useRefresh,
} from "react-admin";
import dataProvider from "server/dataProvider";
import { doctoralRequests } from "api/doctoralApi";
import { useNotifyError } from "utils/useNotifyError";

const EditDocumentTypeForm = ({ campaign, documentType, onDone }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const notifyError = useNotifyError();

  const handleSave = async data => {
    try {
      await dataProvider.customRequest(
        doctoralRequests.updateCampaignDocumentType(campaign.id, documentType.id),
        {
          nameBg: data.nameBg,
          nameEn: data.nameEn,
          isRequired: data.isRequired,
        },
        "PUT",
      );
      notify("Документът е обновен успешно", { type: "success" });
      refresh();
      onDone();
    } catch (err) {
      notifyError(err);
    }
  };

  return (
    <RecordContextProvider value={documentType}>
      <SimpleForm
        toolbar={false}
        onSubmit={handleSave}
        record={documentType}
      >
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={12}
            md={4}
          >
            <TextInput
              source="nameBg"
              label="Наименование на български"
              fullWidth
              validate={required()}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <TextInput
              source="nameEn"
              label="Наименование на английски"
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <NullableBooleanInput
              label="Задължително"
              source="isRequired"
              nullLabel=""
              falseLabel="Не"
              trueLabel="Да"
              fullWidth
              validate={required()}
            />
          </Grid>
        </Grid>
        <Grid sx={{ display: "flex", gap: 3, mt: 2 }}>
          <Button
            variant="outlined"
            startIcon={<CloseIcon />}
            color="error"
            size="small"
            label="Откажи"
            onClick={onDone}
          />
          <SaveButton
            label="Запази"
            size="small"
            alwaysEnable
          />
        </Grid>
      </SimpleForm>
    </RecordContextProvider>
  );
};

export default EditDocumentTypeForm;
